import { Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';

@Injectable()
export class IdleService {
    onIdleStart$ = new Subject<void>();
    onTimeoutWarning$ = new Subject<number>();
    onTimeout$ = new Subject<void>();

    constructor(@Inject(Idle) private idle: Idle) {
        this.idle.setIdle(15 * 60); // 15 min
        this.idle.setTimeout(60);   // 1 min grace
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onIdleStart.subscribe(() => this.onIdleStart$.next());
        this.idle.onTimeoutWarning.subscribe((countdown) => this.onTimeoutWarning$.next(countdown));
        this.idle.onTimeout.subscribe(() => this.onTimeout$.next());
    }

    startWatching() {
        this.idle.watch();
    }

    reset() {
        this.idle.watch(); // restart timer
    }

    stop() {
        this.idle.stop();
    }
}
